var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0936 15.7105C21.1064 15.0594 23.8316 11.2785 23.1804 7.2657C22.5292 3.25289 18.7484 0.527735 14.7356 1.17889C10.7227 1.83004 7.99759 5.61093 8.64875 9.62374C9.2999 13.6365 13.0808 16.3617 17.0936 15.7105Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.855C0 29.9925 3.51349 33.355 7.83695 33.355H24.1631C28.4865 33.355 32 29.9925 32 25.855C32 21.7174 28.4865 18.355 24.1631 18.355H7.83695C3.51349 18.355 0 21.7174 0 25.855Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.0f9311aba74a290c5e674d967eea7c35.svg";
export { ForwardRef as ReactComponent };